/**
 * Цвета
 */
enum PopoverColorEnum {
  /**
   * Белый
   */
  White = "white",
  /**
   * Черный
   */
  Black = "black",
}

export default PopoverColorEnum;
